import React, { useEffect, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { Dropdown, Menu } from '@arco-design/web-react'

export default function ContexMenu({
  visible,
  onVisibleChange,
  menu,
  top,
  left,
  item,
}) {
  const [currentItem, setCurrentItem] = useState(undefined)
  const outsideClick = () => {
    if (visible) onVisibleChange && onVisibleChange(false)
  }
  useEffect(() => {
    setCurrentItem(item)
  }, [item])
  return (
    <div style={{ position: 'absolute', top: top + 'px', left: left + 'px' }}>
      <OutsideClickHandler onOutsideClick={outsideClick}>
        <Dropdown
          trigger=""
          position="br"
          popupVisible={visible}
          droplist={
            <Menu
              ref={(ele) => {
                if (ele)
                  ele.oncontextmenu = new Function('event.returnValue=false')
              }}
            >
              {menu?.map((m, index) => (
                <Menu.Item
                  key={index}
                  onClick={(e) => {
                    m.onClick && m.onClick(currentItem)
                    onVisibleChange && onVisibleChange(false)
                  }}
                  disabled={m.disabled}
                >
                  {m.Icon}
                  <span style={{ color: m.color, marginLeft: '8px' }}>
                    {m.title}
                  </span>
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <div></div>
        </Dropdown>
      </OutsideClickHandler>
    </div>
  )
}
